import React, { useEffect } from "react";
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useAuth } from "@/components/auth/AuthProvider";
import { useGuestSaves } from "@/hooks/use-guest-saves";
import { useNavigate } from "react-router-dom";

export function GuestSavesIndicator() {
  const { user } = useAuth();
  const { guestSaves } = useGuestSaves();
  const navigate = useNavigate();
  
  const savedCount = guestSaves.length;
  
  // Debug logging
  useEffect(() => {
    console.log("GuestSavesIndicator - guestSaves changed:", {
      count: savedCount,
      saves: guestSaves.map(s => ({ name: s.center_name, slug: s.nh_slug }))
    });
  }, [guestSaves, savedCount]);

  console.log("GuestSavesIndicator render - user:", !!user, "savedCount:", savedCount);

  // Only show for guest users with saves
  if (user || savedCount === 0) {
    return null;
  }

  const handleClick = () => {
    navigate("/favorites");
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleClick}
      className="relative text-grandpal-green hover:text-grandpal-green-dark hover:bg-grandpal-green/10"
    >
      <Heart className="h-4 w-4 mr-1 fill-current" />
      <span className="hidden sm:inline">Saved</span>
      <Badge 
        variant="secondary" 
        className="ml-1 bg-grandpal-green text-white hover:bg-grandpal-green"
      >
        {savedCount}
      </Badge>
    </Button>
  );
}